<!-- Ported from the Polaris kit: src/components/ui/select/SelectItem.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { Checkmark16 as Check } from '@carbon/icons-vue';
import { reactiveOmit } from '@vueuse/core';
import {
  SelectItem,
  SelectItemIndicator,
  SelectItemText,
  useForwardProps,
} from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  value: { type: null, required: true },
  disabled: { type: Boolean, required: false },
  textValue: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectItem
    data-slot="select-item"
    v-bind="forwardedProps"
    :class="
      cn(
        `focus:bg-polaris-accent focus:text-polaris-accent-foreground [&_svg:not([class*='text-'])]:text-polaris-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-polaris-sm py-1.5 pr-8 pl-2 type-polaris-body outline-none select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&>span]:last:flex [&>span]:last:items-center [&>span]:last:gap-2`,
        props.class
      )
    "
  >
    <span
      class="absolute right-2 flex size-3.5 items-center justify-center p-0"
    >
      <SelectItemIndicator>
        <slot name="indicator-icon">
          <Check class="size-4 p-0" />
        </slot>
      </SelectItemIndicator>
    </span>

    <SelectItemText>
      <slot />
    </SelectItemText>
  </SelectItem>
</template>
